import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class CheckPrice extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
    };
    render() {
        /**
         * 组件分发数据
         */

        const { content } = this.props;

        const url = `//iauto.ifeng.com/${content}/views/enquire.html`;

        return <a className={styles.enquire} href={url} />;
    }
}

export default CheckPrice;
